import { isGoogleEventsReady, timestamp, getClientID } from '@/utilities'

export function getLast4CC (cardNumber) {
  return cardNumber.replace('-', '').replace(' ', '').slice(-4)
}

export function paymentPageViewEvents () {
  if (isGoogleEventsReady()) {
    const time = timestamp()
    window.gtag('event', 'Ecommerce - PageView', {
      event_category: 'Ecommerce',
      event_label: `${time}~${window.location.href}`,
      send_to: process.env.VUE_APP_UA_ID
    })

    window.gtag('event', 'Ecommerce - PageView', {
      event_category: 'Ecommerce',
      timestamp: time,
      page: 'payment',
      bd_client_id: getClientID(),
      send_to: process.env.VUE_APP_GA4_ID
    })
  }
}

export function submitPaymentEvents () {
  if (isGoogleEventsReady()) {
    const time = timestamp()
    const buttonText = 'Add Payment Information'
    window.gtag('event', 'Ecommerce - PurchaseClicked', {
      event_category: 'Ecommerce',
      event_label: `${time}~${window.location.href}~${buttonText}`,
      send_to: process.env.VUE_APP_UA_ID
    })

    window.gtag('event', 'Ecommerce - PurchaseClicked', {
      event_category: 'Ecommerce',
      button_text: buttonText,
      timestamp: time,
      bd_client_id: getClientID(),
      send_to: process.env.VUE_APP_GA4_ID
    })
  }
}
